import { useEffect, useRef, useState } from "react";
import { Category, Service as ServiceInterface } from "../../others/accomodation.interfaces";
import { arr, repeat, uniqueId } from "../../others/oneliners";
import Service from "../services/Service";
import ServiceCategory, { ServiceCategorySkeleton } from "../services/ServiceCategory";
import { FiChevronLeft } from 'react-icons/fi'
import useScroll from "../../others/useScroll.hook";
import Carousel from "better-react-carousel";
import { useScreenSize } from "../../others/useScreenSize.hook";

interface props {
    categories: Category[] | undefined;
    services: ServiceInterface[],
    accomodationName: string;
    skeleton?: boolean;
}


const ServicesSection = ({ categories, services, accomodationName, skeleton }: props): JSX.Element => {
    const [currentCategory, setCurrentCategory] = useState<string>("");
    const categoriesRef = useRef(null)
    const { size } = useScreenSize()
    const categoriesScrollData = useScroll({ el: categoriesRef });
    useEffect(() => {
        if (categories?.length) setCurrentCategory(categories[0].categoryName + '0')
    }, [categories]);
    if (skeleton) return <ServicesSectionSkeleton />
    const scrollTo = (direction: "left" | "right") => {
        if (direction === 'left') return (categoriesRef.current! as Element).scrollBy(-30, 0)
        if (direction === 'right') return (categoriesRef.current! as Element).scrollBy(30, 0)
    }
    return (
        <div className="flex flex-col gap-3">
            <div className="">
                <h3>Services</h3>
                <span className="text-gray-400">What we offer at {accomodationName}.</span>
            </div>
            <div
                className={"flex flex-row gap-2 w-full lg:w-[900px] max-w-[1000px] overflow-x-scroll no-scrollbar relative pr-4 snap-x snap-mandatory scroll-smooth"}
                dir="ltr"
                ref={categoriesRef}
            >
                <div
                    className={`h-8 w-8 bg-slate-300 rounded-full shadow grid place-content-center sticky shrink-0 cursor-pointer z-10 top-1/2 left-2 -translate-y-1/2 ${categoriesScrollData?.scrollLeft === 40 ? "opacity-0 scale-0" : "opacity-100 scale-100"}`}>
                    <FiChevronLeft className="rotate-0 stroke-black" onClick={() => scrollTo('left')} />
                </div>
                {
                    categories?.map((category, index) => {
                        const key = category.categoryName + index;
                        return (
                            <ServiceCategory
                                key={key}
                                thumbnail={category.thumbnail}
                                categoryName={category.categoryName}
                                className=""
                                _key={key}
                                onClick={() => setCurrentCategory(key)}
                                isCurrent={currentCategory === key}
                            />
                        )
                    })
                }
                <div
                    className={`h-8 w-8 bg-slate-300 rounded-full shadow grid place-content-center sticky shrink-0 cursor-pointer z-10 top-1/2 right-2 -translate-y-1/2 ${categoriesScrollData?.scrollLeft === categoriesScrollData?.scrollLeftMax ? "opacity-0 scale-0" : "opacity-100 scale-100"}`}>
                    <FiChevronLeft className="rotate-180 stroke-black" onClick={() => scrollTo('right')} />
                </div>
            </div>
            <div className="flex gap-3 mt-3 flex-col items-center sm:flex-row">
                {
                    services.map((service, index) => {
                        return (
                            <Service {...service} small={false} key={`service-${index}`}/>
                        )
                    })
                }
            </div>

            <div className="flex flex-col gap-1">
                <h4>More Services</h4>
                <Carousel className="flex gap-3 mt-3 flex-col items-center sm:flex-row" cols={size.xl ? 3 : 1}>
                    {
                        repeat<ServiceInterface>(services[0], 5).map((service, index) => {
                            if (!service) return <></>
                            return (
                                <Carousel.Item key={`service-${uniqueId()}`}>
                                    <Service {...service} small={true} />
                                </Carousel.Item>
                            )
                        })
                    }
                </Carousel>
            </div>
        </div>
    )
}

export default ServicesSection

export const ServicesSectionSkeleton = () => {
    return (
        <div className="flex flex-col gap-2 w-full">
            <h3>Services</h3>
            <div className="flex flex-row gap-2 w-full">
                {
                    arr(4, '').map((val, i: number) => <ServiceCategorySkeleton className="grow" key={`arr-el-${i}`} />)
                }
            </div>
        </div>
    )
}